import React, { Component, Fragment } from 'react';
import { Button, Header, Icon, Loader, Segment, SegmentGroup } from 'semantic-ui-react';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { fetchActiveRole, fetchUserOrganizationalUnit } from '../../util/roles';
import { checkFaculty, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE, getTotalNumberOfPages } from '../../util/util';
import { FiltersOnStyle, IconHeader } from '../../../Professor/ProfessorInputGrades/css';
import NewResource from '../../Resources/NewResource';
import ResourceList from '../../Resources/ResourceList';
import { ToastContainer } from 'react-toastify';
import NewRoom from '../../Rooms/NewRoom';
import PaginationSegment from '../../util/PaginationSegment';


class Resources extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            equipments: [],
            filteredEquipment: [],
            loader: true,
            activeRole: '',
            activePage: 1,
            totalPages: 1,
            resultsPerPage: DEFAULT_NUMBER_OF_ITEMS_PER_PAGE,
            filterRequestData: null,
        };
        this.getUserData = this.getUserData.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.fetchEquipment = this.fetchEquipment.bind(this);
        this.activateEditRequest = this.activateEditRequest.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.updateEquipment = this.updateEquipment.bind(this);
    }

    componentDidMount() {
        localStorage.removeItem('property');
        this.getUserData();
    }

    getUserData() {
        axios.all([fetchActiveRole(), fetchUserOrganizationalUnit()])
            .then(axios.spread((activeRoleRes, userOrganizationalUnitRes) => {
                const activeRole = activeRoleRes.data;
                const organizationalUnitId = userOrganizationalUnitRes.data;
                this.setState({ activeRole, organizationalUnitId });
                if (checkFaculty(activeRole)) {
                    this.fetchEquipment();
                } else {
                    this.fetchEquipment();
                }
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch data.');
            });
    }

    fetchEquipment(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        const pagination = {
            page,
            resultsPerPage,
        };

        return axios.post(`/assets/equipment//by-org-unit-and-property/paginated/${this.props.orgUnitProperty.property.id}`, { ...pagination }).then((res) => {
            const equipments = res.data.responseList;
            let totalPages = getTotalNumberOfPages(res.data.total, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE);
            this.setState({ equipments, totalPages, loader: false });
            this.updateEquipment(page, resultsPerPage, res);
        });
    }

    activateEditRequest() {
        this.setState({ activateEditRequest: true });
    }

    getDataToRender() {
        if (this.state.showFiltersOnButton) {
            return this.state.filteredEquipment;
        }
        return this.state.equipments;
    }

    handlePageChange(e, { activePage }) {
        if (activePage === this.state.activePage) {
            return;
        }

        if (this.state.showFiltersOnButton) {
            this.getFilteredEquipment(activePage - 1, this.state.resultsPerPage);
        } else if (checkFaculty(this.state.activeRole)) {
            this.fetchEquipment(activePage - 1, this.state.resultsPerPage);
        } else {
            this.fetchEquipment(activePage - 1, this.state.resultsPerPage);
        }
    }

    updateEquipment(page, resultsPerPage, res) {
        let totalPages = getTotalNumberOfPages(res.data.total, resultsPerPage);

        this.setState(prevState => ({
            activePage: page + 1,
            resultsPerPage,
            totalPages
        }));
    }

    render() {
        const equipment = this.getDataToRender();
        const {
            openNewResource,
        } = this.state;
        if (this.state.activateEditRequest) {
            return <Redirect push to={{ pathname: '/imovina/sredstva/detalji' }} />;
        }
        return (
            <div>

                {!this.state.openNewResource && checkFaculty(this.state.activeRole) && <Button
                    color="blue"
                    floated="right"
                    icon
                    labelPosition="right"
                    size="small"
                    style={FiltersOnStyle}
                    onClick={() => this.setState({ openNewResource: true })}
                ><Icon className="add" />
                                Dodavanje opreme
                </Button> }
                {!this.state.openNewResource && checkFaculty(this.state.activeRole) && <br />}

                {this.state.openNewResource && <NewResource
                    organizationalUnitId={this.state.organizationalUnitId}
                    activeRole={this.state.activeRole}
                    fetchAllEquipment={this.fetchEquipment}
                    fetchEquipment={this.fetchEquipment}
                    closeForm={() => this.setState({ openNewResource: false })}
                    property={this.props.orgUnitProperty.property}
                    orgUnitProperty={this.props.orgUnitProperty}
                />}
                {this.state.loader ?
                    <Loader active inline="centered" />
                    :

                    equipment && equipment.length ?
                        <Fragment>
                            <ResourceList
                                equipment={equipment}
                                activateEditRequest={this.activateEditRequest}
                            />
                            <PaginationSegment
                                activePage={this.state.activePage}
                                totalPages={this.state.totalPages}
                                onPageChange={this.handlePageChange}
                            />
                        </Fragment>

                        : 'Nema podataka o opremi.'
                }

                <ToastContainer hideProgressBar />

            </div>
        );
    }
}

export default Resources;



// WEBPACK FOOTER //
// ./src/views/Assets/Property/Details/Resources.js